import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [{ text: ['heading-sm', 'nav', 'footer'] }],
      size: [{ size: ['icon-xs', 'icon-sm', 'icon-md', 'icon-lg', 'icon-xl', 'icon-2xl', 'icon-3xl'] }],
      rounded: [{ rounded: ['base', 'input', 'card', 'button'] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
